module.exports = __webpack_public_path__ + "img/baboon_newlogo_red.ee2157fa.png";